import { useLayoutEffect, useState } from "react";
//#region src/hooks/useMemoDebounced.ts
function useMemoDebounced(value, deps, delay) {
	const [debouncedValue, setDebouncedValue] = useState(value);
	if (!deps) throw new Error("deps array is required");
	if (!delay) throw new Error("delay is required");
	useLayoutEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value());
		}, delay);
		return () => {
			clearTimeout(handler);
		};
	}, deps);
	return debouncedValue;
}
//#endregion
export { useMemoDebounced };

//# sourceMappingURL=useMemoDebounced.js.map